__turbopack_context__.v({
  "formContainer": "widget-module-scss-module__iStNVW__formContainer",
  "nflFlepz": "widget-module-scss-module__iStNVW__nflFlepz",
  "nflRflz": "widget-module-scss-module__iStNVW__nflRflz",
});
